export default __webpack_public_path__ + "static/media/CardButtonLeftArrow.838e5c0a.svg";